// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/v1/job_result.proto (package devtool.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/v1/job_result.proto.
 */
export const file_devtool_v1_job_result: GenFile = /*@__PURE__*/
  fileDesc("ChtkZXZ0b29sL3YxL2pvYl9yZXN1bHQucHJvdG8SCmRldnRvb2wudjEingEKCUpvYlJlc3VsdBIOCgZqb2JfaWQYASABKAkSEAoIam9iX3R5cGUYAiABKAkSFQoNam9iX2ZyZXF1ZW5jeRgDIAEoCRInCgxleGVjdXRlX2RhdGUYBCABKAsyES5nb29nbGUudHlwZS5EYXRlEi8KC2V4ZWN1dGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCKVAgoVTGlzdEpvYlJlc3VsdHNSZXF1ZXN0EhUKCGpvYl90eXBlGAEgASgJSACIAQESGgoNam9iX2ZyZXF1ZW5jeRgCIAEoCUgBiAEBEikKCWZyb21fZGF0ZRgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVIAogBARInCgd0b19kYXRlGAQgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUgDiAEBEhIKBWxpbWl0GAUgASgNSASIAQESEwoGb2Zmc2V0GAYgASgNSAWIAQFCCwoJX2pvYl90eXBlQhAKDl9qb2JfZnJlcXVlbmN5QgwKCl9mcm9tX2RhdGVCCgoIX3RvX2RhdGVCCAoGX2xpbWl0QgkKB19vZmZzZXQiWQoWTGlzdEpvYlJlc3VsdHNSZXNwb25zZRIqCgtqb2JfcmVzdWx0cxgBIAMoCzIVLmRldnRvb2wudjEuSm9iUmVzdWx0EhMKC3RvdGFsX2NvdW50GAIgASgNIi0KE0dldEpvYlJlc3VsdFJlcXVlc3QSFgoGam9iX2lkGAEgASgJQga6SAPIAQEiQQoUR2V0Sm9iUmVzdWx0UmVzcG9uc2USKQoKam9iX3Jlc3VsdBgBIAEoCzIVLmRldnRvb2wudjEuSm9iUmVzdWx0QrEBCg5jb20uZGV2dG9vbC52MUIOSm9iUmVzdWx0UHJvdG9QAVpGZ2l0aHViLmNvbS9lbmVjaGFpbi9lcG9zaXRpb24tYXBwL2JhY2tlbmQvZ2VuL3Byb3RvL2RldnRvb2wvdjE7ZGV2dG9vbKICA0RYWKoCCkRldnRvb2wuVjHKAgpEZXZ0b29sXFYx4gIWRGV2dG9vbFxWMVxHUEJNZXRhZGF0YeoCC0RldnRvb2w6OlYxYgZwcm90bzM", [file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * Job result related messages
 *
 * @generated from message devtool.v1.JobResult
 */
export type JobResult = Message<"devtool.v1.JobResult"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: string job_type = 2;
   */
  jobType: string;

  /**
   * @generated from field: string job_frequency = 3;
   */
  jobFrequency: string;

  /**
   * @generated from field: google.type.Date execute_date = 4;
   */
  executeDate?: Date;

  /**
   * @generated from field: google.protobuf.Timestamp executed_at = 5;
   */
  executedAt?: Timestamp;
};

/**
 * Describes the message devtool.v1.JobResult.
 * Use `create(JobResultSchema)` to create a new message.
 */
export const JobResultSchema: GenMessage<JobResult> = /*@__PURE__*/
  messageDesc(file_devtool_v1_job_result, 0);

/**
 * @generated from message devtool.v1.ListJobResultsRequest
 */
export type ListJobResultsRequest = Message<"devtool.v1.ListJobResultsRequest"> & {
  /**
   * Filter by job type
   *
   * @generated from field: optional string job_type = 1;
   */
  jobType?: string;

  /**
   * Filter by job frequency (daily, monthly)
   *
   * @generated from field: optional string job_frequency = 2;
   */
  jobFrequency?: string;

  /**
   * Filter by execute date from
   *
   * @generated from field: optional google.type.Date from_date = 3;
   */
  fromDate?: Date;

  /**
   * Filter by execute date to
   *
   * @generated from field: optional google.type.Date to_date = 4;
   */
  toDate?: Date;

  /**
   * Limit number of results (default: 100)
   *
   * @generated from field: optional uint32 limit = 5;
   */
  limit?: number;

  /**
   * Offset for pagination
   *
   * @generated from field: optional uint32 offset = 6;
   */
  offset?: number;
};

/**
 * Describes the message devtool.v1.ListJobResultsRequest.
 * Use `create(ListJobResultsRequestSchema)` to create a new message.
 */
export const ListJobResultsRequestSchema: GenMessage<ListJobResultsRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_job_result, 1);

/**
 * @generated from message devtool.v1.ListJobResultsResponse
 */
export type ListJobResultsResponse = Message<"devtool.v1.ListJobResultsResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.JobResult job_results = 1;
   */
  jobResults: JobResult[];

  /**
   * @generated from field: uint32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message devtool.v1.ListJobResultsResponse.
 * Use `create(ListJobResultsResponseSchema)` to create a new message.
 */
export const ListJobResultsResponseSchema: GenMessage<ListJobResultsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_job_result, 2);

/**
 * @generated from message devtool.v1.GetJobResultRequest
 */
export type GetJobResultRequest = Message<"devtool.v1.GetJobResultRequest"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;
};

/**
 * Describes the message devtool.v1.GetJobResultRequest.
 * Use `create(GetJobResultRequestSchema)` to create a new message.
 */
export const GetJobResultRequestSchema: GenMessage<GetJobResultRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_job_result, 3);

/**
 * @generated from message devtool.v1.GetJobResultResponse
 */
export type GetJobResultResponse = Message<"devtool.v1.GetJobResultResponse"> & {
  /**
   * @generated from field: devtool.v1.JobResult job_result = 1;
   */
  jobResult?: JobResult;
};

/**
 * Describes the message devtool.v1.GetJobResultResponse.
 * Use `create(GetJobResultResponseSchema)` to create a new message.
 */
export const GetJobResultResponseSchema: GenMessage<GetJobResultResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_job_result, 4);

